import {
    createInscalarTracker,
    StorageAdapter,
} from '@ilg-totallymoney/cardloanutils'
import Cookies from 'js-cookie'

interface CookieYesConsent {
    advertisement?: string
    analytics?: string
    consent?: string
    functional?: string
    necessary?: string
    performance?: string
}

export const createSessionStorageAdapter = (): StorageAdapter => {
    if (typeof window === 'undefined' || !window.sessionStorage) {
        return {
            getItem: () => null,
            setItem: () => undefined,
            removeItem: () => undefined,
        }
    }
    return {
        getItem: key => sessionStorage.getItem(key),
        setItem: (key, value) => sessionStorage.setItem(key, value),
        removeItem: key => sessionStorage.removeItem(key),
    }
}

export const inscalarTracker = createInscalarTracker(
    createSessionStorageAdapter()
)

export const parseCookieYesConsent = (
    cookieValue: string
): CookieYesConsent => {
    return Object.fromEntries(
        cookieValue.split(',').map(pair => pair.split(':'))
    ) as CookieYesConsent
}

export const getHasAnalyticsConsent = (consent: CookieYesConsent): boolean => {
    return consent.consent === 'yes' && consent.analytics === 'yes'
}

export const getCookieYesConsent = (): CookieYesConsent | null => {
    const cookieValue = Cookies.get('cookieyes-consent')
    if (!cookieValue) return null
    return parseCookieYesConsent(cookieValue)
}
